export default __webpack_public_path__ + "static/media/coffee-warmer.4b3f75a5.png";